<template>
  <div class>
    <div class="container-fluid">
      <div class="overview-frame mt-1 mx-0 mx-md-12">
        <template>
          <v-tabs v-model="tab" align-with-title class="top-tab-wrapper mb-4">
            <v-tabs-slider color="#1a73e8"></v-tabs-slider>

            <v-tab
              @click="ChangeTab('Overview')"
              style="font-size: 16px"
              href="#Overview"
              class="ml-0"
            >
              Overview
            </v-tab>

            <v-tab
              @click="ChangeTab('ManageMyEvents')"
              style="font-size: 16px"
              href="#ManageMyEvents"
              class="ml-0"
            >
              Manage My Events
            </v-tab>

            <v-tab
              @click="ChangeTab('PlanDetails')"
              style="font-size: 16px; display: none"
              href="#PlanDetails"
              class="ml-0"
            >
              Plan Details
            </v-tab>

            <div class="all-event-btn position-absolute">
              <router-link
                to="/eventlist"
                style="
                  font-size: 14px;
                  font-weight: 600;
                  display: flex;
                  width: 100%;
                  height: 100%;
                  align-items: center;
                  justify-content: center;
                  color: #2376e5;
                  background: #fff;
                  border-radius: 4px;
                  border: 1px solid #2376e5;
                "
                >View All Events
                <span
                  class="d-inline-block ml-3"
                  style="transform: rotate(180deg)"
                >
                  <img
                    src="../assets/Images/reg-ico/all-events-blue.svg"
                    class=""
                    style="transform: rotate(180deg)"
                  />
                </span>
              </router-link>
            </div>
          </v-tabs>
        </template>

        <v-tabs-items v-model="tab">
          <v-tab-item value="Overview">
            <div class="tab-inner-wrap-section mx-3 mt-4 pb-8">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <div class="overview-welcome-note">
                    <div class="welcome-note">
                      <div
                        class="
                          d-flex
                          justify-content-md-between justify-content-center
                          align-items-center
                        "
                      >
                        <p class="mb-0"></p>
                        <v-btn
                          outlined
                          class="cancel-standard mt-md-0 mt-4"
                          color="#1c1d26"
                          @click="OpenCreateEvent"
                          ><v-icon
                            depressed
                            class="mr-2"
                            color="#1c1d26"
                            size="20px"
                            >mdi-plus</v-icon
                          >Create event</v-btn
                        >
                      </div>
                      <h4>Welcome {{ Userlists.userName }}</h4>
                      <p>
                        You're using e2m.live Free plan! <br />You can host 2
                        events of up to 2 hours long and with as many as 100
                        registrants.
                      </p>
                    </div>
                    <div class="company-logo" v-if="Userlists.userImage !== ''">
                      <img
                        v-bind:src="getCDNUrl(Userlists.userImage)"
                        v-bind:alt="Userlists.userName"
                      />
                    </div>
                    <div class="company-logo" v-else>
                      <span class="circle" style="text-transform: uppercase">
                        {{ getInitials() }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 col-sm-12">
                  <div class="plan-details">
                    <div class="plan-details-head">
                      <div>
                        <p>Your Plan:</p>
                        <div class="plan-mode mt-0"><h4>Free</h4></div>
                      </div>
                      <!-- href="https://projects.invisionapp.com/share/3F125EC9DK92#/screens" -->
                      <v-btn
                        outlined
                        color="#ff9d00"
                        class="d-flex align-items-center"
                        target="_blank"
                        @click="upgradePlan()"
                        ><v-icon
                          class="mr-1"
                          depressed
                          color="#ff9d00"
                          size="20px"
                          >mdi-star</v-icon
                        >
                        Upgrade</v-btn
                      >
                    </div>

                    <div class="plan-format mt-12">
                      <ul>
                        <li>
                          <v-icon depressed color="#959595" size="24px"
                            >mdi-clock</v-icon
                          >
                          <p>2 hours <span>Per event</span></p>
                        </li>
                        <li>
                          <v-icon depressed color="#959595" size="24px"
                            >mdi-ticket-confirmation</v-icon
                          >
                          <p>100 <span>Registrations</span></p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <h3 class="mb-2">Upcoming Events</h3>
                  <h6
                    class="session-time-zone mt-md-1 mb-8"
                    style="color: #8b8b8b"
                  >
                    {{ localTimeZone }}
                  </h6>
                  <div class="d-none">
                    <div class="event-list-wrapper">
                      <h5>Your events will appear hear</h5>
                      <p>Unlock great new opportunities!</p>
                    </div>
                  </div>
                  <div class="event-tile-list">
                    <v-row>
                      <v-col
                        v-for="event in UpcomingEvents"
                        :key="'upcoming_' + event.id"
                        cols="12"
                        md="4"
                        sm="4"
                      >
                        <div
                          class="single-tile-event cursor-pointer"
                          @click="enterInsideEvent(event)"
                        >
                          <div class="upcoming-event-image">
                            <!-- <img src="../assets/Images/dummy-event-image.jpg" /> -->
                            <img :src="event.EventLogo" />
                          </div>
                          <!-- <div class="upcoming-event-manage-div">
                            <div class="d-flex align-items-center flex-column justify-content-center">
                              <v-btn small dark color="#1a73e8">Manage</v-btn>
                              <p>Select Event</p>
                            </div>
                            <div class="d-flex align-items-center flex-column justify-content-center">
                              <v-switch v-model="switch1"></v-switch>
                              <p>Published</p>
                            </div>
                            <div class="d-flex align-items-center flex-column justify-content-center">
                              <v-btn small dark outlined color="#f00">Delete Event</v-btn>
                              <p>Delete</p>
                            </div>
                          </div> -->
                          <div class="upcoming-event-name">
                            <h3>{{ event.Name }}</h3>
                            <p
                              class="
                                mb-0
                                mt-2
                                ml-n4
                                d-flex
                                justify-content-start
                                align-items-center
                              "
                            >
                              <AddEventToCalendar
                                :addToCalendarLabel="event.EventDateStringLabel"
                                :displayLabel="true"
                                :eventTitle="event.Name"
                                :eventStartTimestamp="event.EventStartTimestamp"
                                :eventEndTimestamp="event.EventEndTimestamp"
                              />
                              <!-- <v-icon
                                dark
                                class="mr-1"
                                color="#959595"
                                size="20px"
                                >mdi-calendar-multiselect</v-icon
                              >
                              {{ event.EventStartDateString }}
                              {{
                                event.EventEndDateString !=
                                event.EventStartDateString
                                  ? " - " + event.EventEndDateString
                                  : ""
                              }}
                              {{ event.EventTimezone }} -->
                            </p>
                          </div>
                        </div>
                      </v-col>
                      <div
                        v-if="UpcomingEvents.length == 0"
                        class="overview-info-msg-box"
                      >
                        <h4 class="text-left">Your events will appear here</h4>
                        <h5 class="text-left" style="color: rgb(139, 139, 139)">
                          Unlock great new opportunities!
                        </h5>
                      </div>
                    </v-row>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item value="ManageMyEvents">
            <div
              class="container-fluid ss_event_listTab position-relative px-0"
            >
              <!-----filter-area-->
              <div class="mx-0">
                <div class="evli-filt-wrap ev-filt-wrap mt-0">
                  <div class="row my-0">
                    <div class="col-12 col-md-3 col-sm-4">
                      <div class="form-group mb-0">
                        <div class="new_common_search position-relative mr-0">
                          <v-btn icon color="#f6f8fb" class="filt-cross-btn" @click="searchText = null"><v-icon color="#333" size="15px">mdi-close</v-icon></v-btn>
                          <input
                            placeholder="Search events"
                            class="search-events-input"
                            v-model="searchText"
                          />


                          <div class="reset-search-btn d-none">
                            <p>
                              <i
                                aria-hidden="true"
                                class="
                                  v-icon
                                  notranslate
                                  mdi mdi-close
                                  theme--dark
                                "
                                style="
                                  font-size: 16px;
                                  color: rgb(138, 138, 138);
                                  caret-color: rgb(138, 138, 138);
                                "
                              ></i>
                            </p>
                          </div>


                          <button
                            aria-label="search for events"
                            class="search-submit-button"
                          >
                            <svg
                              width="23"
                              height="18"
                              viewBox="0 0 13 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill="#5a646e"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.25 8.30362L11.9167 10.9735C12.0358 11.106 12.0299 11.3087 11.9033 11.4341L11.4367 11.9013C11.3741 11.9645 11.2889 12 11.2 12C11.1111 12 11.0259 11.9645 10.9633 11.9013L8.29666 9.2314C8.22291 9.1575 8.15597 9.07707 8.09666 8.99111L7.59666 8.32364C6.76937 8.98506 5.74203 9.34518 4.68333 9.34487C2.50174 9.35245 0.606014 7.84573 0.118485 5.71674C-0.369044 3.58774 0.681736 1.40466 2.64873 0.459942C4.61573 -0.484772 6.97398 0.0610084 8.32733 1.77417C9.68068 3.48732 9.66795 5.91064 8.29666 7.60945L8.96333 8.07C9.06744 8.13672 9.16362 8.21509 9.25 8.30362ZM1.35 4.67255C1.35 6.51572 2.84238 8.0099 4.68333 8.0099C5.56739 8.0099 6.41523 7.65829 7.04035 7.03241C7.66548 6.40654 8.01667 5.55767 8.01667 4.67255C8.01667 2.82938 6.52428 1.3352 4.68333 1.3352C2.84238 1.3352 1.35 2.82938 1.35 4.67255Z"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-2 col-sm-3">
                      <div class="form-group position-relative date-img mb-0">
                        <v-btn icon height="15px" width="15px" color="#f6f8fb" class="filt-cross-btn date-cross-btn"  @click="filterDateFrom = null"><v-icon color="#333" size="15px">mdi-close</v-icon></v-btn>
                        <label class="popup-label">From Date</label>
                        <flat-pickr
                          placeholder="MM/DD/YYYY"
                          class="form-control text-uppercase"
                          name="fromDate"
                          v-model="filterDateFrom"
                          :config="configdateTimePickerStart"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-md-2 col-sm-3">
                      <div class="form-group position-relative date-img mb-0">
                        <v-btn icon height="15px" width="15px" color="#f6f8fb" class="filt-cross-btn date-cross-btn" @click="filterDateTo = null"><v-icon color="#333" size="15px">mdi-close</v-icon></v-btn>
                        <label class="popup-label">To Date</label>
                        <!-- <input
                          type="date"
                          class="form-control text-uppercase"
                          placeholder="To Date"
                          :min="filterDateFrom"
                          v-model="filterDateTo"
                        /> -->

                        <flat-pickr
                          placeholder="MM/DD/YYYY"
                          class="form-control text-uppercase"
                          name="toDate"
                          v-model="filterDateTo"
                          :config="configdateTimePickerEnd"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-md-2 col-sm-2">
                      <div class="form-group position-relative mb-0">
                        <label class="popup-label">Status</label>
                        <select class="form-control" v-model="filterStatus">
                          <option value="">All</option>
                          <option value="false">Draft</option>
                          <option value="true">Published</option>
                          <option value="true">Ended</option>
                        </select>
                      </div>
                    </div>
                    <!-- <div class="col text-md-right">
                      <div class="form-group mb-0">
                        <router-link to="/eventlist" class="btn btn-primary px-4 py-2" style="background-image:none;">
                          All Events
                        </router-link>
                      </div>
                    </div> -->
                  </div>

                  <h6
                    class="session-time-zone mt-md-1 mb-4"
                    style="color: #8b8b8b"
                  >
                    {{ localTimeZone }}
                  </h6>
                </div>
                <!----table start--->
                <div class="event-table-wrap">
                  <table class="table ss-event-table" width="100%">
                    <thead>
                      <tr>
                        <th><b>Event Name</b></th>
                        <!-- <th>Start Date</th> -->
                        <!-- <th>End Date</th> -->
                        <th><b>Admins</b></th>
                        <th><b>Status</b></th>
                        <!-- <th>Users Mapped</th> -->
                        <!-- <th>Users Logged In</th> -->
                        <th><b>Actions</b></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="tempAdminEvent && tempAdminEvent.DocPath">
                        <td>
                          <div class="media align-items-center">
                            <div
                              class="ev-sm-imgbox"
                              :style="'background-image: url(https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1623256581214E1637583492067%2FBranding%2F960x192_1639735694081.png?alt=media);'"
                            ></div>
                            <div class="media-body no-listing">
                              <div
                                class="
                                  d-flex
                                  justify-content-start
                                  align-items-center
                                  mb-2
                                "
                              >
                                <h4 class="mb-0">
                                  {{ tempAdminEvent.EventFullName }}
                                </h4>
                                <div class="chip-wrap">
                                  <v-chip
                                    small
                                    class="ml-2"
                                    color="green"
                                    text-color="white"
                                    >NEW</v-chip
                                  >
                                </div>
                              </div>

                              <!-- <p>
                                {{ event.EventStartDateString }} -
                                {{ event.EventEndDateString }}
                              </p> -->
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                            class="
                              d-flex
                              justify-content-center
                              align-items-center
                            "
                          >
                            <!-- <a href="#" class="single-admin-speaker">
                              <img src="../assets/Images/avatar.jpg" />
                            </a>
                            <a href="#" class="single-admin-speaker">
                              <img src="../assets/Images/avatar.jpg" />
                            </a>
                            <a href="#" class="single-admin-speaker">
                              <img src="../assets/Images/avatar.jpg" />
                            </a>
                            <a href="#" class="single-admin-speaker">
                              <img src="../assets/Images/avatar.jpg" />
                            </a>
                            <a href="#" class="single-admin-speaker">
                              <span>DG</span>
                            </a>
                            <a href="#" class="single-admin-speaker">
                              <span>PH</span>
                            </a>
                            <a href="#" class="single-admin-speaker">
                              <v-icon color="#333" size="25px">mdi-plus</v-icon>
                            </a> -->
                          </div>
                        </td>
                        <td>
                          <div class="d-flex flex-column align-items-center">
                            <span class="current-status draft-box text-nowrap">
                              {{
                                tempAdminEvent.Status
                                  ? tempAdminEvent.Status
                                  : "Draft"
                              }}
                            </span>
                          </div>
                        </td>
                        <td
                          v-if="tempAdminEvent && tempAdminEvent.StatusId >= 0"
                        >
                          Processing
                        </td>
                        <td v-else title="Coming Soon">Retry</td>
                      </tr>

                      <tr
                        v-for="event in SearchEventsData"
                        :key="event.id"
                        :class="
                          event.status == 'ended'
                            ? 'ended-session-dark-row'
                            : ''
                        "
                      >
                        <td>
                          <div
                            class="media align-items-center cursor-pointer"
                            @click="enterInsideEvent(event)"
                          >
                            <div
                              class="ev-sm-imgbox"
                              :style="
                                'background-image: url(' +
                                event.EventLogo +
                                ');'
                              "
                            ></div>
                            <!-- <div class="ev-sm-imgbox">
                              <figure>
                                <img
                                  v-bind:src="event.EventLogo"
                                  v-bind:alt="event.Name"
                                />
                              </figure>
                            </div> -->

                            <!-- <div
                              class="ev-sm-imgbox"
                              style="
                                background-image: url(https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2F960X192_white.jpg?alt=media);
                              "
                            >
                            </div> -->
                            <div class="media-body no-listing">
                              <div
                                class="
                                  d-flex
                                  justify-content-start
                                  align-items-center
                                  mb-2
                                "
                              >
                                <h4 class="mb-0">{{ event.Name }}</h4>
                              </div>
                              <p>
                                {{ event.EventStartDateString }}
                                {{
                                  event.EventEndDateString !=
                                  event.EventStartDateString
                                    ? " - " + event.EventEndDateString
                                    : ""
                                }}
                                {{ event.EventTimezone }}
                              </p>
                            </div>
                          </div>
                        </td>
                        <!-- <td>{{ event.EventStartDateString }}</td> -->
                        <!-- <td>{{ event.EventEndDateString }}</td> -->

                        <td>
                          <div
                            class="
                              d-flex
                              justify-content-center
                              align-items-center
                            "
                            v-if="event.AdminList.length > 0"
                          >
                            <a
                              href="javascript:void(0)"
                              data-toggle="modal"
                              data-target="#AddTeamModalCenter"
                              @click="fetchAllAttendees(event)"
                              class="single-admin-speaker"
                              v-for="user in event.AdminList"
                              :key="user.Email"
                            >
                              <img
                                v-if="user.ProfilePictureURL != ''"
                                :src="user.ProfilePictureURL"
                              />
                              <span
                                v-else-if="
                                  user.Name != '' &&
                                  user.ProfilePictureURL == ''
                                "
                                >{{ getAdminInitials(user.Name) }}</span
                              >
                            </a>

                            <a
                              href="javascript:void(0)"
                              data-toggle="modal"
                              data-target="#AddTeamModalCenter"
                              @click="fetchAllAttendees(event)"
                              class="single-admin-speaker"
                              v-if="event && event.AdminList.length >= 4"
                            >
                              <v-icon color="#333" size="25px">mdi-plus</v-icon>
                            </a>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex flex-column align-items-center">
                            <span
                              :class="
                                event.IsPublished
                                  ? 'current-status published-box'
                                  : 'current-status draft-box'
                              "
                              >{{
                                event.IsPublished ? "Published" : "Draft"
                              }}</span
                            >

                            <span
                              v-if="event.status == 'ended'"
                              class="
                                current-status
                                d-inline-block
                                session-ended
                                mt-2
                              "
                              >Ended</span
                            >
                          </div>
                        </td>

                        <!-- <td>400</td> -->
                        <!-- <td>200</td> -->
                        <td>
                          <div class="d-flex justify-content-center">
                            <button
                              class="ev-manage"
                              type="button"
                              @click="enterInsideEvent(event)"
                            >
                              Manage
                            </button>
                            <v-menu offset-y max-width="250px">
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  class="evcircle-ac-dp"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <label>...</label>
                                </span>
                              </template>
                              <v-list>
                                <v-list-item dense="true">
                                  <p
                                    class="team-text"
                                    @click="openAdminInviteSection(event)"
                                  >
                                    Add Team Member
                                  </p>
                                </v-list-item>
                                <v-list-item dense="true" id="vap">
                                  <p
                                    class="team-text"
                                    data-toggle="modal"
                                    data-target="#AddTeamModalCenter"
                                    @click="fetchAllAttendees(event)"
                                  >
                                    Manage Team
                                  </p>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </div>
                        </td>
                      </tr>

                      <tr
                        v-if="
                          EventsLoaded &&
                          EventsData.length > 0 &&
                          SearchEventsData.length == 0 &&
                          !tempAdminEvent
                        "
                      >
                        <td colspan="9">
                          <div class="text-center p-4">
                            <h4 class="text-left">
                              No matches found for your Search
                            </h4>
                          </div>
                        </td>
                      </tr>

                      <tr
                        v-if="
                          EventsLoaded &&
                          EventsData.length == 0 &&
                          (!tempAdminEvent ||
                            (tempAdminEvent &&
                              tempAdminEvent.DocPath == undefined))
                        "
                      >
                        <td colspan="9">
                          <div class="text-center p-4">
                            <h4 class="text-left">
                              There are currently no events to manage.
                            </h4>
                          </div>
                        </td>
                      </tr>
                      <!-- <tr>
                        <td>
                          <div class="media align-items-center">
                            <div
                              class="ev-sm-imgbox"
                              style="
                                background-image: url(https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2F960X192_white.jpg?alt=media);
                              "
                            >
                            </div>
                            <div class="media-body no-listing">
                              <h4>Lorem ipsum dolor sit amet</h4>
                              <p>Jul 16,05:00 PM - DEC 31,05:00 PM</p>
                            </div>
                          </div>
                        </td>
                        <td>Oct 14, 05:00 PM</td>
                        <td>Oct 14, 05:00 PM</td>
                        <td>Draft</td>
                        <td>400</td>
                        <td>200</td>
                        <td>
                          <div class="d-flex justify-content-center">
                            <button class="ev-manage btn btn-default" type="button">
                              Manage
                            </button>
                            <span class="evcircle-ac-dp">
                              <label>...</label>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="media align-items-center">
                            <div
                              class="ev-sm-imgbox"
                              style="
                                background-image: url(https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2F960X192_white.jpg?alt=media);
                              "
                            >
                            </div>
                            <div class="media-body no-listing">
                              <h4>Lorem ipsum dolor sit amet</h4>
                              <p>Jul 16,05:00 PM - DEC 31,05:00 PM</p>
                            </div>
                          </div>
                        </td>
                        <td>Oct 14, 05:00 PM</td>
                        <td>Oct 14, 05:00 PM</td>
                        <td>Draft</td>
                        <td>400</td>
                        <td>200</td>
                        <td>
                          <div class="d-flex justify-content-center">
                            <button class="ev-manage btn btn-default" type="button">
                              Manage
                            </button>
                            <span class="evcircle-ac-dp">
                              <label>...</label>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="media align-items-center">
                            <div
                              class="ev-sm-imgbox"
                              style="
                                background-image: url(https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2F960X192_white.jpg?alt=media);
                              "
                            >
                            </div>
                            <div class="media-body no-listing">
                              <h4>Lorem ipsum dolor sit amet</h4>
                              <p>Jul 16,05:00 PM - DEC 31,05:00 PM</p>
                            </div>
                          </div>
                        </td>
                        <td>Oct 14, 05:00 PM</td>
                        <td>Oct 14, 05:00 PM</td>
                        <td>Draft</td>
                        <td>400</td>
                        <td>200</td>
                        <td>
                          <div class="d-flex justify-content-center">
                            <button class="ev-manage btn btn-default" type="button">
                              Manage
                            </button>
                            <span class="evcircle-ac-dp">
                              <label>...</label>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="media align-items-center">
                            <div
                              class="ev-sm-imgbox"
                              style="
                                background-image: url(https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2F960X192_white.jpg?alt=media);
                              "
                            >
                            </div>
                            <div class="media-body no-listing">
                              <h4>Lorem ipsum dolor sit amet</h4>
                              <p>Jul 16,05:00 PM - DEC 31,05:00 PM</p>
                            </div>
                          </div>
                        </td>
                        <td>{{ EventStartDateString }}</td>
                        <td>{{ EventEndDateString }}</td>
                        <td>Draft</td>
                        <td>400</td>
                        <td>200</td>
                        <td>
                          <div class="d-flex justify-content-center">
                            <button class="ev-manage btn btn-default" type="button">
                              Manage
                            </button>
                            <span class="evcircle-ac-dp">
                              <label>...</label>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="media align-items-center">
                            <div
                              class="ev-sm-imgbox"
                              style="
                                background-image: url(https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2F960X192_white.jpg?alt=media);
                              "
                            >
                            </div>
                            <div class="media-body no-listing">
                              <h4>Lorem ipsum dolor sit amet</h4>
                              <p>Jul 16,05:00 PM - DEC 31,05:00 PM</p>
                            </div>
                          </div>
                        </td>
                        <td>{{ EventStartDateString }}</td>
                        <td>{{ EventEndDateString }}</td>
                        <td>Draft</td>
                        <td>400</td>
                        <td>200</td>
                        <td>
                          <div class="d-flex justify-content-center">
                            <button class="ev-manage btn btn-default" type="button">
                              Manage
                            </button>
                            <span class="evcircle-ac-dp">
                              <label>...</label>
                            </span>
                          </div>
                        </td>
                      </tr> -->
                    </tbody>
                  </table>
                </div>
                <!----table end--->

                <div class="addmore-person d-none" id="invite-admin-section">
                  <div class="team-invite-form">
                    <p class="mb-6 small-head" style="border-top: none">
                      Invite More Members
                    </p>
                    
                    <v-row justify="space-between">
                      <v-col cols="12" md="6" sm="6">
                        <v-row>
                          <v-col cols="12" md="6" sm="6">
                            <label>First Name</label>
                            <input
                              type="text"
                              name=""
                              id="admin-invite-fname"
                              value=""
                              v-model="adminFName"
                            />
                          </v-col>
                          <v-col cols="12" md="6" sm="6">
                            <label>Last Name</label>
                            <input
                              type="text"
                              name=""
                              id=""
                              value=""
                              v-model="adminLName"
                            />
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="12" md="3" sm="3">
                        <label>Email</label>
                        <input
                          type="email"
                          name=""
                          id=""
                          value=""
                          v-model="adminEmail"
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3">
                        <label>Company</label>
                        <input
                          type="email"
                          name=""
                          id=""
                          value=""
                          v-model="adminCompany"
                        />
                      </v-col>

                      <v-col cols="12" md="3" sm="3">
                        <v-select
                          :items="adminTypes"
                          item-text="name"
                          item-value="value"
                          label="Type"
                          dense
                          v-model="adminTypeInvite"
                          height="38px"
                        ></v-select>
                      </v-col>

                      <v-col cols="12" lg="3" md="4" sm="6">
                        <div
                          class="
                            d-flex
                            align-items-center
                            justify-content-end mr-space
                          "
                        >
                          <v-btn
                            dark
                            large
                            outlined
                            color="#333"
                            class="mr-2"
                            width="100%"
                            @click="closeAdminInvites()"
                            >Cancel</v-btn
                          >

                          <v-btn
                            dark
                            large
                            color="#1a73e8"
                            width="100%"
                            @click="sendAdminInvites()"
                            >Send</v-btn
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>
          <!-- Plan Details start-->
          <v-tab-item value="PlanDetails" style="display: none">
            <div class="plan-details-wrapper">
              <div class="pland-d-billing-tab d-flex">
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <a class="active" data-toggle="tab" href="#overview"
                      >Overview</a
                    >
                  </li>
                  <li class="nav-item">
                    <a data-toggle="tab" href="#billingHistory"
                      >Billing History</a
                    >
                  </li>
                  <li class="nav-item">
                    <a data-toggle="tab" href="#add-ons">Add-ons</a>
                  </li>
                </ul>
              </div>
              <div class="container-fluid grey-bg">
                <div class="mx-8 py-5 tab-content">
                  <div
                    class="evnt-usg-inner-wrap tab-pane active"
                    id="overview"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <h4 class="m-0 bold-text">Event Usage Snapshot</h4>
                      <v-btn depressed color="warning">
                        <v-icon class="pr-2" color="#ffffff" size="20px"
                          >mdi-star</v-icon
                        >
                        Upgrade
                      </v-btn>
                    </div>
                    <div class="row mt-2">
                      <!---box  start-->
                      <div class="col-md-3">
                        <div class="event-usage-box blue accent-3">
                          <div class="eus-img-box">
                            <img
                              src="../assets/Images/plan-details/subscribed.svg"
                            />
                          </div>
                          <h5>Subscribed Events</h5>
                          <h2>97</h2>
                        </div>
                      </div>
                      <!---box  end-->
                      <div class="col-md-3">
                        <div class="event-usage-box">
                          <div class="eus-img-box">
                            <img
                              src="../assets/Images/plan-details/remaining.svg"
                            />
                          </div>
                          <h5 class="red--text">Remaining</h5>
                          <h2 class="red--text">0</h2>
                        </div>
                      </div>
                      <!---box  end-->
                      <div class="col-md-3">
                        <div class="event-usage-box">
                          <div class="eus-img-box">
                            <img
                              src="../assets/Images/plan-details/published.svg"
                            />
                          </div>
                          <h5>Published</h5>
                          <h2>13</h2>
                        </div>
                      </div>
                      <!---box  end-->
                      <div class="col-md-3">
                        <div class="event-usage-box">
                          <div class="eus-img-box">
                            <img
                              src="../assets/Images/plan-details/unpublished.svg"
                            />
                          </div>
                          <h5>Unpublished</h5>
                          <h2>97</h2>
                        </div>
                      </div>
                      <!---box  end-->
                      <div class="col-md-3">
                        <div class="event-usage-box">
                          <div class="eus-img-box">
                            <img
                              src="../assets/Images/plan-details/completed.svg"
                            />
                          </div>
                          <h5>Completed</h5>
                          <h2>97</h2>
                        </div>
                      </div>
                      <!---box  end-->
                      <div class="col-md-3">
                        <div class="event-usage-box">
                          <div class="eus-img-box">
                            <img
                              src="../assets/Images/plan-details/deleted.svg"
                            />
                          </div>
                          <h5>Deleted</h5>
                          <h2>97</h2>
                        </div>
                      </div>
                      <!---box  end-->
                      <div class="col-md-3">
                        <div class="event-usage-box">
                          <div class="eus-img-box">
                            <img
                              src="../assets/Images/plan-details/archived.svg"
                            />
                          </div>
                          <h5>Archived</h5>
                          <h2>97</h2>
                        </div>
                      </div>
                      <!---box  end-->
                      <div class="col-md-3">
                        <div class="event-usage-box">
                          <div class="eus-img-box">
                            <img
                              src="../assets/Images/plan-details/total-users.svg"
                            />
                          </div>
                          <h5>Total Users</h5>
                          <h2>9473</h2>
                        </div>
                      </div>
                      <!---box  end-->
                    </div>
                  </div>
                  <!--Billing History start-->
                  <div
                    class="billing_history-wrapper tab-pane fade"
                    id="billingHistory"
                  >
                    <div class="col-12">
                      <div class="row">
                        <!--left start-->
                        <div class="col-md-4">
                          <div class="billing-history-left rounded border">
                            <div class="py-3 black">
                              <h4 class="text-center m-0 white--text">
                                Current Plan
                              </h4>
                            </div>
                            <div class="p-4 white">
                              <div class="text-center yellow lighten-5">
                                <div class="start-plan p-5">
                                  <h4 class="mb-1">Started Plan</h4>
                                  <p class="mb-0">Ideal for small events</p>
                                </div>
                              </div>
                              <ul>
                                <li>Includes 30 Registrations</li>
                                <li>Max event duration: 1 day</li>
                                <li>Max 1 Event</li>
                              </ul>
                              <p class="text-center">
                                <v-btn depressed color="warning">
                                  <v-icon
                                    class="pr-2"
                                    color="#ffffff"
                                    size="20px"
                                    >mdi-star</v-icon
                                  >
                                  Upgrade
                                </v-btn>
                              </p>
                              <p class="py-4 text-center">
                                See our complete <a href="#">plan comparison</a>
                              </p>
                            </div>
                          </div>
                        </div>
                        <!--left end-->
                        <!--right sidebar start-->
                        <div class="col-md-8 billing-history-right">
                          <h5 class="text-bold pb-3">Subscription Details</h5>
                          <!--ubscription Details start-->
                          <div class="history-right-table border">
                            <div class="table-responsive">
                              <table class="table table-bordered mb-0 white">
                                <thead>
                                  <tr>
                                    <th scope="col">Subscription Type:</th>
                                    <th scope="col">Subscribe date</th>
                                    <th scope="col">Expiry date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <h2>Starter Plan</h2>
                                      <p>Ideal for small events</p>
                                    </td>
                                    <td><h4>14.12.2021</h4></td>
                                    <td><h4>14.12.2022</h4></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <!--ubscription Details end-->
                          <!---->
                          <h5 class="text-bold pb-3 mt-8">History</h5>
                          <div class="history-right-table border">
                            <div class="table-responsive history-table">
                              <table class="table table-bordered mb-0 white">
                                <thead>
                                  <tr>
                                    <th scope="col">Subscription Type:</th>
                                    <th scope="col">Validity Form</th>
                                    <th scope="col">Validity Untill</th>
                                    <th scope="col">Download Invoice</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>Free Plan</td>
                                    <td>14.12.2021</td>
                                    <td>Single event Licence</td>
                                    <td>
                                      <img
                                        src="../assets/Images/icons/download.svg"
                                        width="15px"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <!--ubscription Details end-->
                        </div>
                        <!--right sidebar end-->
                      </div>
                    </div>
                  </div>
                  <!--Billing History end-->
                  <!--add-ons-->
                  <div id="add-ons" class="tab-pane fade">
                    <!---->
                    <div class="col-md-12">
                      <h4 class="text-bold">Upgrage features using add-ons</h4>
                      <div class="row add-ons-wrapper my-0">
                        <div class="col-8 add-ons-left py-0">
                          <div class="row add-ons-wrapper my-0">
                            <div class="col-md-6">
                              <!---media start-->
                              <div class="media">
                                <div class="media-top">
                                  <img
                                    class="mr-3"
                                    src="../assets/Images/plan-details/exhibitors.png"
                                    alt=" image"
                                  />
                                  <div class="media-body">
                                    <h5 class="mt-0">Exhibitors</h5>
                                    <p class="ad-sub-info">
                                      <span
                                        ><i class="fa fa-dollar"></i> 99</span
                                      >
                                      per 10 Exhibitors
                                    </p>
                                  </div>
                                </div>
                                <p class="ad-sub-info mb-2">
                                  Add more than 500 and save 20%
                                </p>
                                <div
                                  class="
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                    full-width
                                  "
                                >
                                  <!---plus minus start-->
                                  <div class="input-group">
                                    <input
                                      type="text"
                                      name="quant[1]"
                                      class="form-control input-number"
                                      value="1"
                                      min="1"
                                      max="10"
                                    />
                                    <span class="input-group-btn">
                                      <button
                                        type="button"
                                        class="btn btn-default btn-number"
                                        disabled="disabled"
                                        data-type="minus"
                                        data-field="quant[1]"
                                      >
                                        <img
                                          src="../assets/Images/icons/minus.svg"
                                          alt="minus"
                                        />
                                      </button>
                                    </span>
                                    <span class="input-group-btn">
                                      <button
                                        type="button"
                                        class="btn btn-default btn-number"
                                        data-type="plus"
                                        data-field="quant[1]"
                                      >
                                        <img
                                          src="../assets/Images/icons/plus.svg"
                                          alt="minus"
                                        />
                                      </button>
                                    </span>
                                  </div>
                                  <!--plus minus end-->
                                  <v-btn class="py-4 ml-2" color="success"
                                    ><v-icon size="15" color="white"
                                      >mdi-check
                                    </v-icon>
                                    Added
                                  </v-btn>
                                </div>
                              </div>
                              <!---media end-->
                            </div>
                            <div class="col-md-6">
                              <!---media start-->
                              <div class="media">
                                <div class="media-top">
                                  <img
                                    class="mr-3"
                                    src="../assets/Images/plan-details/sponsors.png"
                                    alt=" image"
                                  />
                                  <div class="media-body">
                                    <h5 class="mt-0">Sponsors</h5>
                                    <p class="ad-sub-info">
                                      <span
                                        ><i class="fa fa-dollar"></i> 99</span
                                      >
                                      per 10 Exhibitors
                                    </p>
                                  </div>
                                </div>
                                <p class="ad-sub-info mb-2">
                                  Add more than 500 and save 20%
                                </p>
                                <div
                                  class="
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                    full-width
                                  "
                                >
                                  <!---plus minus start-->
                                  <div class="input-group">
                                    <input
                                      type="text"
                                      name="quant[1]"
                                      class="form-control input-number"
                                      value="1"
                                      min="1"
                                      max="10"
                                    />
                                    <span class="input-group-btn">
                                      <button
                                        type="button"
                                        class="btn btn-default btn-number"
                                        disabled="disabled"
                                        data-type="minus"
                                        data-field="quant[1]"
                                      >
                                        <img
                                          src="../assets/Images/icons/minus.svg"
                                          alt="minus"
                                        />
                                      </button>
                                    </span>
                                    <span class="input-group-btn">
                                      <button
                                        type="button"
                                        class="btn btn-default btn-number"
                                        data-type="plus"
                                        data-field="quant[1]"
                                      >
                                        <img
                                          src="../assets/Images/icons/plus.svg"
                                          alt="minus"
                                        />
                                      </button>
                                    </span>
                                  </div>
                                  <!--plus minus end-->
                                  <v-btn class="py-4 ml-2" color="primary"
                                    ><v-icon size="15" color="white"
                                      >mdi-plus
                                    </v-icon>
                                    Add
                                  </v-btn>
                                </div>
                              </div>
                              <!---media end-->
                            </div>
                            <div class="col-md-6">
                              <!---media start-->
                              <div class="media">
                                <div class="media-top">
                                  <img
                                    class="mr-3"
                                    src="../assets/Images/plan-details/chztbot.png"
                                    alt=" image"
                                  />
                                  <div class="media-body">
                                    <h5 class="mt-0">Zoe Chatbot</h5>
                                    <p class="ad-sub-info">
                                      <span
                                        ><i class="fa fa-dollar"></i> 99</span
                                      >
                                    </p>
                                  </div>
                                </div>
                                <div
                                  class="
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                    full-width
                                  "
                                >
                                  <p class="mb-0">Max 5 events</p>
                                  <v-btn class="py-4 ml-2" color="primary"
                                    ><v-icon size="15" color="white"
                                      >mdi-plus
                                    </v-icon>
                                    Add
                                  </v-btn>
                                </div>
                              </div>
                              <!---media end-->
                            </div>

                            <div class="col-md-6">
                              <!---media start-->
                              <div class="media">
                                <div class="media-top">
                                  <img
                                    class="mr-3"
                                    src="../assets/Images/plan-details/check-in.png"
                                    alt=" image"
                                  />
                                  <div class="media-body">
                                    <h5 class="mt-0">Check-in App</h5>
                                    <p class="ad-sub-info">
                                      <span
                                        ><i class="fa fa-dollar"></i> 249</span
                                      >
                                    </p>
                                  </div>
                                </div>
                                <div
                                  class="
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                    full-width
                                  "
                                >
                                  <p class="mb-0">Max 5 events</p>
                                  <v-btn class="py-4 ml-2" color="success"
                                    ><v-icon size="15" color="white"
                                      >mdi-check
                                    </v-icon>
                                    Added
                                  </v-btn>
                                </div>
                              </div>
                              <!---media end-->
                            </div>

                            <div class="col-md-6">
                              <!---media start-->
                              <div class="media">
                                <div class="media-top">
                                  <img
                                    class="mr-3"
                                    src="../assets/Images/plan-details/roundtables.png"
                                    alt=" image"
                                  />
                                  <div class="media-body">
                                    <h5 class="mt-0">Roundtables</h5>
                                    <p class="ad-sub-info">
                                      <span
                                        ><i class="fa fa-dollar"></i> 99</span
                                      >
                                      per 10 Exhibitors
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <!---media end-->
                            </div>
                            <div class="col-md-6">
                              <!---media start-->
                              <div class="media">
                                <div class="media-top">
                                  <img
                                    class="mr-3"
                                    src="../assets/Images/plan-details/chztbot.png"
                                    alt=" image"
                                  />
                                  <div class="media-body">
                                    <h5 class="mt-0">Follow-up Cadence</h5>
                                    <p class="ad-sub-info">
                                      <span
                                        ><i class="fa fa-dollar"></i>99</span
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <!---media end-->
                            </div>
                          </div>
                        </div>
                        <!---right section-->
                        <div class="col-4 reg-right-side register_popup">
                          <div class="reg-r-inner-w border">
                            <h3 class="bold-text pb-2">Order Summary</h3>
                            <table class="full-width">
                              <tr>
                                <td class="pb-0">
                                  Exhibitors
                                  <span class="grey--text">(50)</span>
                                </td>
                                <td class="pb-0">
                                  <i class="fa fa-dollar"></i>495.00
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  Check-in App
                                  <span class="grey--text">(5 events)</span>
                                </td>
                                <td><i class="fa fa-dollar"></i>495.00</td>
                              </tr>
                              <tr>
                                <td colspan="2" class="position-relative">
                                  <div class="circle circle-cu-left"></div>
                                  <div class="circle circle-cu-right"></div>
                                  <hr />
                                </td>
                              </tr>
                              <tr>
                                <td colspan="2">
                                  <h5 class="bold-text text-left">
                                    Use Coupon Code
                                  </h5>
                                  <div
                                    class="form-group position-relative reg-cc"
                                  >
                                    <input
                                      type="Text"
                                      placeholder="Enter Coupon Code"
                                      class="form-control"
                                    />
                                    <button class="btn btn-default">
                                      APPLY
                                    </button>
                                  </div>
                                  <hr />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="bold-text pb-2">Total Amount</h5>
                                </td>
                                <td>
                                  <h5 class="bold-text t-pr pb-2">
                                    <i class="fa fa-dollar"></i>744
                                  </h5>
                                </td>
                              </tr>
                            </table>
                            <div class="tick-btn-cont">
                              <v-btn color="primary" class="full-width">
                                Continue
                              </v-btn>
                            </div>
                          </div>
                        </div>
                        <!---right section-->
                      </div>
                    </div>
                    <!---->
                  </div>
                  <!--add-ons end-->
                </div>
              </div>
            </div>
          </v-tab-item>

          <!-- <v-tab-item>
            <div class="billing-wrapper mx-10 mt-4 pb-8">
              <div class="d-flex justify-content-between align-items-center">
                <h3>Event Usage Snapshot</h3>
                <div class="d-flex justify-content-end align-items-center">
                  <v-btn dark color="#1a73e8" class="mr-2">
                    <v-icon dark class="mr-2" color="#fff" size="20px"
                      >mdi-tray-arrow-down</v-icon
                    >
                    Download Report</v-btn
                  >
                  <v-btn dark color="#1a73e8" class="mr-2">
                    <v-icon dark class="mr-2" color="#fff" size="20px"
                      >mdi-currency-usd</v-icon
                    >
                    Purchase</v-btn
                  >
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-md-4">
                  <div class="event-subscriber-count">
                    <img src="../assets/Images/reg-ico/subscribed.svg" />
                    <p>Subscribed Events</p>
                    <h2>97</h2>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="remaining-subscribe">
                    <img src="../assets/Images/reg-ico/remaining.svg" />
                    <p>Remaining</p>
                    <h3>0</h3>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="common-info-box">
                    <img src="../assets/Images/reg-ico/published.svg" />
                    <p>Published</p>
                    <h3>13</h3>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="common-info-box">
                    <img src="../assets/Images/reg-ico/unpublished.svg" />
                    <p>Unpublished</p>
                    <h3>81</h3>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="common-info-box">
                    <img src="../assets/Images/reg-ico/completed.svg" />
                    <p>Completed</p>
                    <h3>93</h3>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-4">
                  <div class="user-analyze-count">
                    <div
                      class="d-flex justify-content-start align-items-center"
                    >
                      <img src="../assets/Images/reg-ico/deleted.svg" />
                      <p>Deleted</p>
                    </div>
                    <div>
                      <h3>3</h3>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="user-analyze-count">
                    <div
                      class="d-flex justify-content-start align-items-center"
                    >
                      <img src="../assets/Images/reg-ico/archived.svg" />
                      <p>Archived</p>
                    </div>
                    <div>
                      <h3>26</h3>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="user-analyze-count">
                    <div
                      class="d-flex justify-content-start align-items-center"
                    >
                      <img src="../assets/Images/reg-ico/total-users.svg" />
                      <p>Total Users</p>
                    </div>
                    <div>
                      <h3>9473</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item> -->

          <v-tab-item value="InviteMyTeam">
            <div class="tab-inner-wrap-section mx-10 mt-4 pb-8 px-1">
              <h3>Team</h3>
              <!-- <div class="single-team-wrap mt-8">
                <div class="row">
                  <div class="col-md-2">
                    <p><b>Name</b></p>
                  </div>
                  <div class="col-md-10">
                    <input
                      type="text"
                      name=""
                      id=""
                      value="Dipesh Kumar Majumder"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2">
                    <p><b>Email</b></p>
                  </div>
                  <div class="col-md-10">
                    <input
                      type="Email"
                      name=""
                      id=""
                      value="dipesh.majumder@webspiders.com"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2">
                    <p><b>Designation</b></p>
                  </div>
                  <div class="col-md-10">
                    <input type="text" name="" id="" value="Product Manager" />
                  </div>
                </div>
              </div>

              <div class="single-team-wrap mt-8">
                <div class="row">
                  <div class="col-md-2">
                    <p><b>Name</b></p>
                  </div>
                  <div class="col-md-10">
                    <input type="text" name="" id="" value="" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2">
                    <p><b>Email</b></p>
                  </div>
                  <div class="col-md-10">
                    <input type="Email" name="" id="" value="" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2">
                    <p><b>Designation</b></p>
                  </div>
                  <div class="col-md-10">
                    <input type="text" name="" id="" value="" />
                  </div>
                </div>
              </div>
              <v-btn dark color="primary"
                ><v-icon dark color="#fff" size="20px">mdi-plus</v-icon> Add New
                Team Member</v-btn
              > -->
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade addteam-member"
      id="AddTeamModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-add-team-head">
              <h3>Manage Team</h3>

              <span
                ><v-icon
                  color="#333"
                  size="25px"
                  data-dismiss="modal"
                  aria-label="Close"
                  >mdi-close</v-icon
                ></span
              >
            </div>
            <div
              class="
                yellow-warning
                d-flex
                justify-content-between
                align-items-center
              "
            >

              <p>
                {{eventAdminList.length}} of 5 members invited.
                <span>Upgrade to add more members.</span>
              </p>
              <v-btn dark color="#fbbc2d"> Upgrade</v-btn>
            </div>
            <div class="invite-contact mt-8">
              <div class="d-flex justify-content-center">
                <v-progress-circular
                  v-if="showAdminListLoader"
                  indeterminate
                  color="primary"
                  size="70"
                ></v-progress-circular>
              </div>
              <table width="100%">
                <tbody>
                  <tr v-for="admin in eventAdminList" :key="admin.id">
                    <td>
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <div
                          class="headshot-profile mr-3"
                          v-if="admin.ProfilePictureURL"
                        >
                          <img :src="admin.ProfilePictureURL" />
                        </div>
                        <div class="headshot-profile mr-3" v-else>
                          <img src="../assets/Images/avatar.jpg" />
                        </div>
                        {{ admin.Name }}
                      </div>
                    </td>
                    <td>{{ admin.Email }}</td>
                     <td>
                      <v-select
                        :items="adminTypes"
                        item-text="name"
                        item-value="value"
                        label="Type"
                        dense
                        v-model="eventAdminMemberType"
                        disabled
                      ></v-select>
                    </td>
                   <!-- <td>
                      <div
                        class="
                          d-flex-justify-content-between
                          align-items-center
                        "
                      >
                        <v-btn outlined dark color="#1a73e8" class="mr-4"
                          ><v-icon class="mr-2" color="#1a73e8" size="#1a73e8"
                            >mdi-email-sync-outline</v-icon
                          >Re-send Invitation</v-btn
                        >
                        <v-btn text color="#959595">Remove</v-btn>
                      </div>
                    </td> -->
                  </tr>

                  <tr v-for="admin in analyticsAdminList" :key="admin.id">
                    <td>
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <div
                          class="headshot-profile mr-3"
                          v-if="admin.ProfilePictureURL"
                        >
                          <img :src="admin.ProfilePictureURL" />
                        </div>
                        <div class="headshot-profile mr-3" v-else>
                          <img src="../assets/Images/avatar.jpg" />
                        </div>
                        {{ admin.Name }}
                      </div>
                    </td>
                    <td>{{ admin.Email }}</td>
                    <td>
                      <v-select
                        :items="adminTypes"
                        item-text="name"
                        item-value="value"
                        label="Type"
                        dense
                        v-model="analyticsAdminMemberType"
                        disabled
                      ></v-select>
                    </td>
                    <!-- <td>
                      <div
                        class="
                          d-flex-justify-content-between
                          align-items-center
                        "
                      >
                        <v-btn outlined dark color="#1a73e8" class="mr-4"
                          ><v-icon class="mr-2" color="#1a73e8" size="#1a73e8"
                            >mdi-email-sync-outline</v-icon
                          >Re-send Invitation</v-btn
                        >
                        <v-btn text color="#959595">Remove</v-btn>
                      </div>
                    </td> -->
                  </tr>

                  <!-- <tr>
                    <td>
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <div class="headshot-profile mr-3">
                          <img src="../assets/Images/avatar.jpg" />
                        </div>
                        Andrew Anderson
                      </div>
                    </td>
                    <td>andrew@lehbro.org</td>
                    <td>
                      <v-select
                        :items="items"
                        label="Member Type"
                        dense
                      ></v-select>
                    </td>
                    <td>
                      <div
                        class="
                          d-flex-justify-content-between
                          align-items-center
                        "
                      >
                        <v-btn outlined dark color="#1a73e8" class="mr-4"
                          ><v-icon class="mr-2" color="#1a73e8" size="#1a73e8"
                            >mdi-email-sync-outline</v-icon
                          >Re-send Invitation</v-btn
                        >
                        <v-btn text color="#959595">Remove</v-btn>
                      </div>
                    </td>
                  </tr> -->

                  <!-- <tr>
                    <td>
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <div class="headshot-profile mr-3">
                          <img src="../assets/Images/avatar.jpg" />
                        </div>
                        Andrew Anderson
                      </div>
                    </td>
                    <td>andrew@lehbro.org</td>
                    <td>
                      <v-select
                        :items="items"
                        label="Member Type"
                        dense
                      ></v-select>
                    </td>
                    <td>
                      <div
                        class="
                          d-flex-justify-content-between
                          align-items-center
                        "
                      >
                        <v-btn outlined dark color="#1a73e8" class="mr-4"
                          ><v-icon class="mr-2" color="#1a73e8" size="#1a73e8"
                            >mdi-email-sync-outline</v-icon
                          >Re-send Invitation</v-btn
                        >
                        <v-btn text color="#959595">Remove</v-btn>
                      </div>
                    </td>
                  </tr> -->

                  <!-- <tr>
                    <td>
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <div class="headshot-profile mr-3">
                          <img src="../assets/Images/avatar.jpg" />
                        </div>
                        Andrew Anderson
                      </div>
                    </td>
                    <td>andrew@lehbro.org</td>
                    <td>
                      <v-select
                        :items="items"
                        label="Member Type"
                        dense
                      ></v-select>
                    </td>
                    <td>
                      <div
                        class="
                          d-flex-justify-content-between
                          align-items-center
                        "
                      >
                        <v-btn outlined dark color="#1a73e8" class="mr-4"
                          ><v-icon class="mr-2" color="#1a73e8" size="#1a73e8"
                            >mdi-email-sync-outline</v-icon
                          >Re-send Invitation</v-btn
                        >
                        <v-btn text color="#959595">Remove</v-btn>
                      </div>
                    </td>
                  </tr> -->

                  <!-- <tr>
                    <td>
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <div class="headshot-profile mr-3">
                          <img src="../assets/Images/avatar.jpg" />
                        </div>
                        Andrew Anderson
                      </div>
                    </td>
                    <td>andrew@lehbro.org</td>
                    <td>
                      <v-select
                        :items="items"
                        label="Member Type"
                        dense
                      ></v-select>
                    </td>
                    <td>
                      <div
                        class="
                          d-flex-justify-content-between
                          align-items-center
                        "
                      >
                        <v-btn outlined dark color="#1a73e8" class="mr-4"
                          ><v-icon class="mr-2" color="#1a73e8" size="#1a73e8"
                            >mdi-email-sync-outline</v-icon
                          >Re-send Invitation</v-btn
                        >
                        <v-btn text color="#959595">Remove</v-btn>
                      </div>
                    </td>
                  </tr> -->

                  <!-- <tr>
                    <td>
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <div class="headshot-profile mr-3">
                          <img src="../assets/Images/avatar.jpg" />
                        </div>
                        Andrew Anderson
                      </div>
                    </td>
                    <td>andrew@lehbro.org</td>
                    <td>
                      <v-select
                        :items="items"
                        label="Member Type"
                        dense
                      ></v-select>
                    </td>
                    <td>
                      <div
                        class="
                          d-flex-justify-content-between
                          align-items-center
                        "
                      >
                        <v-btn outlined dark color="#1a73e8" class="mr-4"
                          ><v-icon class="mr-2" color="#1a73e8" size="#1a73e8"
                            >mdi-email-sync-outline</v-icon
                          >Re-send Invitation</v-btn
                        >
                        <v-btn text color="#959595">Remove</v-btn>
                      </div>
                    </td>
                  </tr> -->

                  <!-- <tr>
                    <td>
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <div class="headshot-profile mr-3">
                          <img src="../assets/Images/avatar.jpg" />
                        </div>
                        Andrew Anderson
                      </div>
                    </td>
                    <td>andrew@lehbro.org</td>
                    <td>
                      <v-select
                        :items="items"
                        label="Member Type"
                        dense
                      ></v-select>
                    </td>
                    <td>
                      <div
                        class="
                          d-flex-justify-content-between
                          align-items-center
                        "
                      >
                        <v-btn outlined dark color="#1a73e8" class="mr-4"
                          ><v-icon class="mr-2" color="#1a73e8" size="#1a73e8"
                            >mdi-email-sync-outline</v-icon
                          >Re-send Invitation</v-btn
                        >
                        <v-btn text color="#959595">Remove</v-btn>
                      </div>
                    </td>
                  </tr> -->

                  <!-- <tr>
                    <td>
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <div class="headshot-profile mr-3">
                          <img src="../assets/Images/avatar.jpg" />
                        </div>
                        Andrew Anderson
                      </div>
                    </td>
                    <td>andrew@lehbro.org</td>
                    <td>
                      <v-select
                        :items="items"
                        label="Member Type"
                        dense
                      ></v-select>
                    </td>
                    <td>
                      <div
                        class="
                          d-flex-justify-content-between
                          align-items-center
                        "
                      >
                        <v-btn outlined dark color="#1a73e8" class="mr-4"
                          ><v-icon class="mr-2" color="#1a73e8" size="#1a73e8"
                            >mdi-email-sync-outline</v-icon
                          >Re-send Invitation</v-btn
                        >
                        <v-btn text color="#959595">Remove</v-btn>
                      </div>
                    </td>
                  </tr> -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---pricing popup---->
    <v-dialog
      v-model="eventPricingPlan"
      scrollable
      fullscreen
      transition="dialog-bottom-transition"
     
    >
      <v-card class="eventPricingPlan ">
        <v-card-text>
          <iframe
            
            :src='pricingURl'
            width="100%"
            height="100%"
          ></iframe>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-content-end">
          <v-btn
            text
            @click="eventPricingPlan = false"
            class="mr-2"
            outlined
            large
            color="#000"
            width="122px"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---pricing popup---->
  </div>
</template>
<script>
// import HelloWorld from "@/components/HelloWorld.vue";
// import Router from "vue-router";
// import firebase from "firebase";
import APIs from "@/components/APIInit";
import db from "../components/firebaseInit";
import firebase from "firebase";
import store from "../store";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import axios from "axios";
import { bus } from "@/main";
import jwt_decode from "jwt-decode";
import common from "@/common";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import AddEventToCalendar from "@/components/AddToCalendar.vue";

Vue.use(VueMoment, {
  moment,
});

var self;
var eventCloneProgress;
export default {
  components: {
    flatPickr,
    AddEventToCalendar,
  },
  data() {
    return {
      EventsLoaded: false,
      showAdminListLoader: true,
      eventAdminList: [],
      analyticsAdminList: [],
      attendeeList: [],
      tempAdminEvent: null,
      uid: "",
      APIs: APIs,
      noEventLink: "https://e2m.live/",
      EventsData: [],
      clientID: "", //this.$store.getters.getClient[0].id,
      BannerURL: "",
      noEventMessage: false,
      isMobileSearch: false,
      mobileBanner: "",
      desktopBanner: "",
      ShowCreateEventButton: false,
      searchText: "",
      filterDateFrom: "",
      filterDateTo: "",
      filterStatus: "",
      tab: null,
      switch1: true,
      radioGroup: 1,
      adminTypes: [
        { name: "Event Admin", value: "EventAdmin" },
        { name: "Analytics Admin", value: "AnalyticsAdmin" },
      ],
      eventAdminMemberType: "EventAdmin",
      analyticsAdminMemberType: "AnalyticsAdmin",
      selectedEventDetails: {},
      adminCompany: null,
      adminEmail: null,
      adminLName: null,
      adminFName: null,
      adminTypeInvite: "Event Admin",
      localTimeZone: "",
      configdateTimePickerStart: {
        enableTime: false,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      configdateTimePickerEnd: {
        minDate: null,
        enableTime: false,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      eventPricingPlan: false,
      pricingURl:"",
    };
  },
  computed: {
    UpcomingEvents() {
      var result = [];
      var currentTimeS = parseInt(new Date().getTime() / 1000);
      result = self.EventsData.filter(function (item) {
        if (currentTimeS < item.EventEndDateS) {
          return true;
        }
      });
      result = result.sort(function compare(a, b) {
        var dateA = a.EventStartDateS;
        var dateB = b.EventStartDateS;
        return dateA - dateB;
      });
      return result;
    },
    Userlists() {
      var firstName = "";
      var pPic = "";
      var lastname = "";
      var Email = "";
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj != undefined && obj !== null) {
        if (obj.user != undefined && obj.user != null) {
          if (obj.user.length > 0) {
            if (obj.user[0].fname !== undefined) {
              firstName = obj.user[0].fname;
            }
             if (obj.user[0].fname !== undefined) {
              lastname = obj.user[0].lname;
            }
             if (obj.user[0].fname !== undefined) {
              Email = obj.user[0].Email;
            }
            if (obj.user[0].profilepic !== undefined) {
              pPic = obj.user[0].profilepic;
            }
          }
        }
      }
      return {
        userName: firstName,
        userImage: pPic,
        userLastName:lastname,
        userEmail:Email
      };
    },
    hasSession() {
      if (self.uid) {
        return true;
      } else {
        return false;
      }
    },
    SearchEventsData() {
      var result = [];
      var searchText = (self.searchText ? self.searchText : "")
        .trim()
        .toLowerCase();
      if (!searchText) {
        result = self.EventsData.filter(function () {
          return true;
        });
      } else {
        result = self.EventsData.filter(function (item) {
          if (item.Name.toLowerCase().includes(searchText.toLowerCase())) {
            return true;
          }
        });
      }
      if (self.filterDateFrom) {
        let filterDateFrom = new Date(self.filterDateFrom);
        let startSeconds = parseInt(filterDateFrom.getTime() / 1000);
        result = result.filter(function (item) {
          if (startSeconds < item.EventEndDateS) {
            return true;
          }
        });
      }
      if (self.filterDateTo) {
        let filterDateTo = new Date(self.filterDateTo);
        filterDateTo.setDate(filterDateTo.getDate() + 1);
        let endSeconds = parseInt(filterDateTo.getTime() / 1000);
        result = result.filter(function (item) {
          if (endSeconds > item.EventEndDateS) {
            return true;
          }
        });
      }
      if (self.filterStatus) {
        var filterStatus = self.filterStatus == "true" ? true : false;
        result = result.filter(function (item) {
          return item.IsPublished == filterStatus;
        });
      }

      var currentTimeS = parseInt(new Date().getTime() / 1000);
      var liveResult = result.filter(function (item) {
        if (currentTimeS < item.EventEndDateS) {
          return true;
        }
      });
      var pastResult = result.filter(function (item) {
        if (currentTimeS >= item.EventEndDateS) {
          return true;
        }
      });
      liveResult = liveResult.sort(function compare(a, b) {
        var dateA = a.EventStartDateS;
        var dateB = b.EventStartDateS;
        return dateA - dateB;
      });
      pastResult = pastResult.sort(function compare(a, b) {
        var dateA = a.EventStartDateS;
        var dateB = b.EventStartDateS;
        return dateB - dateA;
      });
      return liveResult.concat(pastResult);
    },
  },
  watch: {
    //searchText(val) {
    //  alert(val);
    //},
  },
  beforeCreate() {
    // setTimeout(() => {
    //   setTimeout(() => {
    //     setTimeout(() => {
    //       $("#app").addClass("full-screen");
    //     }, 100);
    //     $("#app").addClass("full-screen");
    //   }, 100);
    //   $("#app").addClass("full-screen");
    // }, 100);
    // $("#app").addClass("full-screen");
  },
  async beforeRouteUpdate(to, from, next) {
    next(true);
    self.tempAdminEvent = null;
    self.CreateEventProgress();
    let urlParams = String(window.location.href).split("#");

    if (
      urlParams.length > 1 &&
      urlParams[1].toLowerCase() == "managemyevents"
    ) {
      self.tab = "ManageMyEvents";
    }
  },
  created() {
    self = this;
    this.localTimeZone = common.getTimeZoneName();
    self.uid = self.getSessionUserId();
    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });

    let urlParams = String(window.location.href).split("#");
    if (
      urlParams.length > 1 &&
      urlParams[1].toLowerCase() == "managemyevents"
    ) {
      self.tab = "ManageMyEvents";
    }

    // turn off user welcome loader from login
    var data = {
      showUserWelcomeLoader: false,
    };

    bus.$emit("setUserWelcomeLoader", data);
  },
  mounted() {
    self.CreateEventProgress();
    self.noEventLink = self.$t("client.registerRoute");
    self.clientID = self.$route.query.c;
    //this.clientID = self.$route.params.c;
    /* $("#alleventSec").css("background-size", "cover");
    $("#alleventSec").css("background-color", "none");
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    $("#alleventSec").css(
      "background-image",
      "url(" + obj.branding[0].bg2 + ")"
    );
    $("#alleventSec").css("background-size", "100%");
    //alert(obj.Branding[0].banner)
    $("#imgBanner").attr("src", obj.branding[0].banner);

    $(".clsDynamicColor").css("color", obj.branding[0].bodyTextColor);*/
    //debugger;
    // $("#topmenu").hide();
    // $("#leftmenu").hide();
    // var obj = JSON.parse(window.localStorage.getItem("my-app"));
    // this.BannerURL = obj.branding[0].banner;
    /*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
    //  self.tid =
    //   this.$route.params.tid == undefined ? "" : this.$route.params.tid;

    //-------------------------GEt client id by host---------------------------------------
    //self.clientID = this.$route.params.c;
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      //this.result = "uatonair.e2m.live";
      //self.hostName = "onair.e2m.live";
      self.hostName = HOSTURL ? HOSTURL : "uatonair.e2m.live";
      // self.hostName = "uatbni.e2m.live";
      // this.result = "tci.e2m.live";
      //this.result = "uatcapitalgroup.e2m.live";
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
      //self.hostName = location.host;
    }
    var path;
    //console.log(self.hostName);
    if (this.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = APIs.googleSoragePath;
    }
    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then((res) => {
        if (res && res.data) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        self.clientID = res.data.ClientId;
        //self.clientName = res.data.ClientName;
        document.title = res.data.ClientName;
        if (
          res.data.EventListAssets &&
          res.data.EventListAssets.banner2048x88
        ) {
          self.desktopBanner = res.data.EventListAssets.banner2048x88;
        }
        if (
          res.data.EventListAssets &&
          res.data.EventListAssets.banner750x103
        ) {
          self.mobileBanner = res.data.EventListAssets.banner750x103;
        }
        self.initScreen();
        self.EventsData = [];
        self.displayEvents();
      });
  },
  methods: {
    upgradePlan() {
      this.pricingURl="https://e2m.live/pricing?mode=embed&custFName="+ this.Userlists.userName+ "&custLName="+ this.Userlists.userLastName + "&email=" + this.Userlists.userEmail;
      this.eventPricingPlan = true;
       
    },
    CreateEventProgress() {
      self.tempAdminEvent = self.$store.getters.getTempAdminEvent;
      if (self.tempAdminEvent && !self.tempAdminEvent.DocPath) {
        self.tempAdminEvent = null;
      }
      if (self.tempAdminEvent && self.tempAdminEvent.DocPath) {
        //self.tempAdminEvent.Status = "In Progress";
        if (eventCloneProgress) {
          eventCloneProgress();
          eventCloneProgress = undefined;
        }
        eventCloneProgress = db
          .doc(self.tempAdminEvent.DocPath)
          .onSnapshot((doc) => {
            if (doc.exists) {
              let data = doc.data();
              self.tempAdminEvent.StatusId = parseInt(data.status);
              if (isNaN(self.tempAdminEvent.StatusId)) {
                self.tempAdminEvent.StatusId = 0;
              }
              //alert("in "+self.tempAdminEvent.StatusId);
              self.tempAdminEvent.Status = data.msg;

              self.tempAdminEvent = {
                DocPath: self.tempAdminEvent.DocPath,
                EventFullName: self.tempAdminEvent.EventFullName,
                StatusId: self.tempAdminEvent.StatusId,
                Status: self.tempAdminEvent.Status,
              };
              if (self.tempAdminEvent.StatusId == 200) {
                if (eventCloneProgress) {
                  eventCloneProgress();
                  eventCloneProgress = undefined;
                }
                self.tempAdminEvent = null;
                store.commit("setTempAdminEvent", {});
                self.refreshIdToken();
              } else if (self.tempAdminEvent.StatusId < 0) {
                self.showSnackbar(
                  "Something went wrong. Click Retry to create the event",
                  "error",
                  "top"
                );
              }
            }
          });
      }
    },
    OpenCreateEvent() {
      //bus.$emit("OpenCreateEvent");
      router.push("/showcase");
    },
    sendAdminInvites() {
      // let docObj = {
      //   EventId: self.selectedEventDetails.id,
      //   EventCollectionName: self.selectedEventDetails.EventCollectionName,
      //   EventFullName: self.selectedEventDetails.Name.trim(),
      //   EventAdminId: null,
      //   FirstName: self.adminFName.trim(),
      //   LastName: self.adminLName.trim(),
      //   Company: self.adminCompany,
      //   Email: self.adminEmail.trim(),
      //   Password: null,
      //   AdminType: self.adminTypeInvite,
      //   ClientId: self.selectedEventDetails.clientID,
      // };

      let attendeObj = {
        AttendeeId: null,
        EventId: self.selectedEventDetails.id,
        Name: self.adminFName + " " + self.adminLName,
        FirstName: self.adminFName,
        LastName: self.adminLName,
        Email: self.adminEmail,
        Password: null,
        Phone: "",
        Country: "",
        Company: self.adminCompany,
        Designation: null,
        Profile: "",
        ProfilePictureURL: "",
        Website: "",
        SocialLinks: [
          { Facebook: "" },
          { GooglePlus: "" },
          { LinkedIn: "" },
          { Twitter: "" },
        ],
        Tags: "",
        MailSent: false,
        IsVerified: false,
        IsPublished: true,
        UserRoles: [{ RoleID: 10, RoleName: "AppUser" }],
        AdminType: self.adminTypeInvite,
      };

      if (attendeObj.AdminType == "EventAdmin") {
        attendeObj.IsEventAdmin = true;
      } else {
        attendeObj.IsAnalyticsAdmin = true;
      }

      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
        "x-api-key": APIs.DeleteAttendeeApiKey,
      };
      let requestData = {
        key: {
          eventId: self.selectedEventDetails.id,
          clientId: self.selectedEventDetails.clientID,
          instanceId: "OA_UAT",
        },
        data: attendeObj,
        sendMail: 0,
      };
      axios
        .post(APIs.CheckUserStatus, requestData, { headers: headers })
        .then((res) => {
          let prevRoles =
            res && res.data && res.data.result && res.data.result.AdminRoles
              ? res.data.result.AdminRoles
              : [];
          let prevRoleFound = prevRoles.some(
            (el) =>
              el.ClientId == self.selectedEventDetails.clientID &&
              el.EventId == self.selectedEventDetails.id &&
              el.RoleName == attendeObj.AdminType
          );
          if (!prevRoleFound) {
            axios
              .post(APIs.AddSingleAttendee, requestData, { headers: headers })
              .then(function (userRes) {
                if (userRes.status == 200) {
                  // self.sendMail(docObj);
                  self.selectedEventDetails = {};
                  self.adminCompany = null;
                  self.adminEmail = null;
                  self.adminLName = null;
                  self.adminFName = null;
                  self.adminTypeInvite = "Event Admin";

                  self.showSnackbar(
                    "Admin Created & Mail Sent.",
                    "success",
                    "top"
                  );
                  self.closeAdminInvites();
                } else {
                  self.showSnackbar("Admin not Created!", "error", "top");
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            self.showSnackbar(
              "Already has the role of " + self.adminTypeInvite,
              "error",
              "top"
            );
          }
        });
    },
    openAdminInviteSection(event) {
      self.selectedEventDetails = event;
      document
        .getElementById("invite-admin-section")
        .classList.remove("d-none");
      document.getElementById("admin-invite-fname").focus();
    },
    closeAdminInvites() {
      document.getElementById("invite-admin-section").classList.add("d-none");
    },
    //     sendMail(field) {
    //   var html = "";
    //   var cn = field.EventCollectionName;
    //   let subject = "You are Invited to manage:";
    //   var clientRef = db.collection("OA_UAT").doc("ClientList").collection("Clients")
    //   let promise = new Promise(() => {
    //     clientRef
    //       .doc(field.ClientId)
    //       .get()
    //       .then(function (clientDetail) {
    //         db
    //           .collection(cn)
    //           .doc("EventInfo")
    //           .get()
    //           .then(function (eventDetail) {
    //             if (field.AdminType == "EventAdmin") {
    //               db
    //                 .collection(cn)
    //                 .doc("mailtpl")
    //                 .collection("EventAdmin")
    //                 .doc("WelcomeMail")
    //                 .get()
    //                 .then(function (mailtpl) {
    //                   let source = mailtpl.data().html;
    //                   let template = Handlebars.compile(source);
    //                   context
    //                     .dispatch("getUserDetailbyId", `${field.EventAdminId}`)
    //                     .then((userDetail) => {
    //                       let formatedText = {
    //                         CustomDomain: clientDetail.data().CustomDomain,
    //                         EventName: eventDetail.data().EventFullName,
    //                         CMSDomain: window.location.hostname,
    //                         Email: userDetail.Email,
    //                         Password: userDetail.Password,
    //                         FirstName: userDetail.FirstName,
    //                         EventBanner: eventDetail.data().EventBanner,
    //                         ClientEmail: clientDetail.data().ClientEmail,
    //                       };
    //                       html = template(formatedText);
    //                       subject = mailtpl
    //                         .data()
    //                         .subject.replace(
    //                           "{{EventName}}",
    //                           eventDetail.data().EventFullName
    //                         );
    //                       var requestData = {
    //                         from: {
    //                           email: mailtpl.data().from
    //                             ? mailtpl.data().from
    //                             : "noreply@mail.e2m.live",
    //                           name:
    //                             "E2M OnAir: " +
    //                             eventDetail.data().EventFullName,
    //                         },
    //                         to: {
    //                           name: userDetail.Name,
    //                           email: userDetail.Email.toLowerCase(),
    //                         },
    //                         //"subject": "You're in - " + ls.getSessionValueByKey('Session_Event_FullName'),
    //                         subject: subject,
    //                         html: html,
    //                       };
    //                       const headers = {
    //                         "Content-Type": "application/json",
    //                         Authorization: "Bearer " + self.getSessionToken(),
    //                       };
    //                       axios
    //                         .post(SINGLEEMAILAPIURL, requestData, {
    //                           headers: headers,
    //                         })
    //                         .then((response) => {
    //                           if (response.status == 200) {
    //                             console.log({
    //                               status: 200,
    //                               message: "Mail sent to User",
    //                             });
    //                           }
    //                         })
    //                         .catch((error) => {
    //                           console.log(error);
    //                         });
    //                     });
    //                 });
    //             } else {
    //                db
    //                 .collection(cn)
    //                 .doc("mailtpl")
    //                 .collection("AnalyticsAdmin")
    //                 .doc("WelcomeMail")
    //                 .get()
    //                 .then(function (mailtpl) {
    //                   let source = mailtpl.data().html;
    //                   let template = Handlebars.compile(source);
    //                   context
    //                     .dispatch("getUserDetailbyId", `${field.EventAdminId}`)
    //                     .then((userDetail) => {
    //                       let formatedText = {
    //                         CustomDomain: clientDetail.data().CustomDomain,
    //                         EventName: eventDetail.data().EventFullName,
    //                         CMSDomain: window.location.hostname,
    //                         Email: userDetail.Email,
    //                         Password: userDetail.Password,
    //                         FirstName: userDetail.FirstName,
    //                         EventBanner: eventDetail.data().EventBanner,
    //                         ClientEmail: clientDetail.data().ClientEmail,
    //                       };
    //                       html = template(formatedText);
    //                       subject = mailtpl
    //                         .data()
    //                         .subject.replace(
    //                           "{{EventName}}",
    //                           eventDetail.data().EventFullName
    //                         );
    //                       var requestData = {
    //                         from: {
    //                           email: mailtpl.data().from
    //                             ? mailtpl.data().from
    //                             : "noreply@mail.e2m.live",
    //                           name:
    //                             "E2M OnAir: " +
    //                             eventDetail.data().EventFullName,
    //                         },
    //                         to: {
    //                           name: userDetail.Name,
    //                           email: userDetail.Email.toLowerCase(),
    //                         },
    //                         //"subject": "You're in - " + ls.getSessionValueByKey('Session_Event_FullName'),
    //                         subject: subject,
    //                         html: html,
    //                       };
    //                       const headers = {
    //                         "Content-Type": "application/json",
    //                         Authorization: "Bearer " + self.getSessionToken(),
    //                       };
    //                       axios
    //                         .post(SINGLEEMAILAPIURL, requestData, {
    //                           headers: headers,
    //                         })
    //                         .then((response) => {
    //                           if (response.status == 200) {
    //                             console.log({
    //                               status: 200,
    //                               message: "Mail sent to User",
    //                             });
    //                           }
    //                         })
    //                         .catch((error) => {
    //                           console.log(error);
    //                         });

    //                       //})
    //                     }); // end of where in firebase
    //                 });
    //             }
    //           }); // end of event
    //       });
    //   }); // end of promise
    //   return promise;
    // },
    getInitials() {
      return common.getInitials(this.$store.state.user[0].name);
    },
    getAdminInitials(name) {
      return common.getInitials(name);
    },
    fetchAllAttendees(events) {
      //console.log("events>>>>>>>>>>",events);

      // $("#AddTeamModalCenter").show();

      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };

      let rqstData = {};

      rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: events.clientID,
          eventId: events.id,
        },

        data: {
          search: [],
          filter: [],
          sort: { sortBy: "FirstName", sortOrder: "asc" },
          pagination: {
            Page: 1,
            PageSize: 2000,
          },
          origin: "COMPACT",
        },
      };
      axios
        .post(APIs.GetAdmins, rqstData, {
          headers: headers,
        })
        .then((responseData) => {
          self.attendeeList = [];
          self.eventAdminList = [];
          self.analyticsAdminList = [];

          console.log("responseData-----", responseData);
          self.showAdminListLoader = false;

          responseData.data.result.map((attendee) => {
            console.log("attendee-----", attendee);

            if (attendee.UserRoles[0] == 3) {
              // adminEvents.push(attendee);
              self.eventAdminList.push(attendee);
            } else if (attendee.UserRoles[0] == 4) {
              //  analyticsEvents.push(attendee);
              self.analyticsAdminList.push(attendee);
            }

            // self.attendeeList.push({
            //   name: attendee.Name ? attendee.Name.trim() : "",
            //   id: attendee.AttendeeId,
            //   profilePictureURL: self.getCDNUrl(attendee.ProfilePictureURL),
            //   company: attendee.Company,
            //   designation: attendee.Designation,
            //   registrationType: attendee.RegistrationType,
            //   email: attendee.Email,
            // });
          });
          console.log("analyticsAdminList-----", self.analyticsAdminList);
          console.log("eventAdminList-----", self.eventAdminList);

          // var adminEvents = [];
          // var analyticsEvents = [];
          // self.eventAdminList = [];
          // self.analyticsAdminList = [];
          // db.collection(events.EventCollectionName)
          //   .doc("AdminList")
          //   .collection("Admins")
          //   .get()
          //   .then((querySnapshot) => {
          //     querySnapshot.forEach((doc) => {
          //       if (doc.data().Roles[0] == 3) {
          //         adminEvents.push(doc.data().UserId);
          //       } else if (doc.data().Roles[0] == 4) {
          //         analyticsEvents.push(doc.data().UserId);
          //       }
          //     });

          //     console.log("adminEvents>>>>>>>", adminEvents);
          //     console.log("analyticsEvents>>>>>>>", analyticsEvents);

          //     if (adminEvents.length > 0 || analyticsEvents.length > 0) {
          //       // self.attendeeList.filter((attendee) =>
          //       //   adminEvents.includes(attendee.id)
          //       // );
          //       self.showAdminListLoader = false;
          //       console.log("adminEvents>>>>>>>", adminEvents);

          //       self.attendeeList.map((attendee) => {
          //         if (
          //           adminEvents.length > 0 &&
          //           attendee.id.includes(adminEvents)
          //         ) {
          //           self.eventAdminList.push(attendee);
          //           self.analyticsAdminList.push(attendee);
          //         } else if (
          //           analyticsEvents.length > 0 &&
          //           attendee.id.includes(analyticsEvents)
          //         ) {
          //           self.analyticsAdminList.push(attendee);
          //         }
          //       });
          //     }
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //     // console.log("Error getting documents: ", error);
          //   });
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    enterInsideEvent(event) {
      self.ChangeCurrentEvent(event.clientID, event.id, true);
    },
    ChangeTab(tab) {
      self.tab = tab;
      debugger;
      location.hash = tab;
      //router.push("")
    },
    Logout() {
      bus.$emit("clearState");
    },
    initScreen() {
      if (window.innerWidth > 768) {
        self.isMobileSearch = false;
        self.BannerURL = self.desktopBanner;
      } else {
        self.isMobileSearch = true;
        self.BannerURL = self.mobileBanner;
      }
    },
    stopShimmer() {
      $(".shimmer-effect").css("display", "none");
    },
    mob_elist_search() {
      $("#mob_ev_search").css("display", "block");
      $(".mob_search_button").css("opacity", "0 ");
    },
    billing_History() {
      $(".evnt-usg-inner-wrap").css("display", "none");
      $(".billing_history-wrapper").css("display", "block");
    },
    DisplayCreateEventPopup() {
      //$("#SignUpModal").modal("show");
    },
    refreshIdToken() {
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          firebase
            .auth()
            .currentUser.getIdToken(true)
            .then((idToken) => {
              var decoded = jwt_decode(idToken);
              document.cookie = "token=";
              document.cookie = "token=" + idToken + ";";
              store.commit("setCurrentLoggedInTime", decoded.exp);
              store.commit("addToken", idToken);
              self.displayEvents();
            })
            .catch((err) => {
              console.log("token set error==", err);
            });
        }
      });
    },
    displayEvents() {
      bus.$emit("toggleLoader", true);
      var mappedEvents = [];
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      axios
        .get(self.APIs.UserEvent, {
          headers: headers,
        })
        .then((response) => {
          self.EventsData = [];
          var clients = response.data.result;
          var AdminRoles = [];
          if (response.data.profile && response.data.profile.AdminRoles) {
            store.commit("setAdminRoles", response.data.profile.AdminRoles);
            AdminRoles = response.data.profile.AdminRoles;
            // ClientId: "C1591205467009";
            // EventId: "E1637219036051";
            // RoleID: 3;
            // RoleName: "EventAdmin";
          }
          for (var n = 0; n < clients.length; n++) {
            var client = clients[n];
            var events = client.events;
            var currentTime = parseInt(new Date().getTime() / 1000);
            for (var i = 0; i < events.length; i++) {
              var event = events[i];
              mappedEvents.push(event);
              var dtstrt = parseInt(
                new Date(event.EventStartDateTime).getTime() / 1000
              );
              var dtEnd = parseInt(
                new Date(event.EventEndDateTime).getTime() / 1000
              );

              if (dtstrt > currentTime) {
                event.status = "upcoming";
              } else if (dtstrt <= currentTime && dtEnd >= currentTime) {
                if (!event.IsPublished) {
                  event.status = "underreview";
                } else {
                  event.status = "live";
                }
              } else {
                event.status = "ended";
              }

              var adminEvents = AdminRoles.filter(function (item) {
                return (
                  item.ClientId == event.ClientId &&
                  item.EventId == event.EventId
                );
              });

              if (adminEvents.length == 0) {
                continue;
              }
              let startTime = event.EventStartDateTime.substring(11, 16);
              let endTime = event.EventEndDateTime.substring(11, 16);
              debugger;
              var eventNewStartTime = self.SetTimeByZone(
                moment(event.EventStartDate, ["DD-MM-YYYY"]).format(
                  "MMM DD, YYYY"
                ),
                moment.tz.guess()
              );
              var eventNewEndTime = self.SetTimeByZone(
                moment(event.EventEndDate, ["DD-MM-YYYY"]).format(
                  "MMM DD, YYYY"
                ),
                moment.tz.guess()
              );

              var eventDateStringLabel =
                eventNewStartTime != eventNewEndTime
                  ? eventNewStartTime + " to " + eventNewEndTime
                  : eventNewStartTime;

              self.EventsData.push({
                id: event.EventId,
                AdminList: event.Admins,
                Name: event.EventFullName,
                EventLogo: self.getCDNUrl(event.EventLogo),
                EventStartDate: event.EventStartDate,
                EventEndDate: event.EventEndDate,
                EventStartTimestamp: event.EventStartDateTimestamp,
                EventEndTimestamp: event.EventEndtDateTimestamp,
                EventDateStringLabel: eventDateStringLabel,
                EventCollectionName: event.EventCollectionName,
                EventTypeId: event.EventTypeId,
                EventTimezone: moment.tz.guess(), // data.TimeZone,
                EventStartDateS: event.EventStartDateTimestamp,
                EventEndDateS: event.EventEndtDateTimestamp,
                EventNewStartTime: self.SetTimeByZone(
                  moment(event.EventStartDate, ["DD-MM-YYYY"]).format(
                    "MMM DD, YYYY"
                  ) +
                    " " +
                    startTime,
                  moment.tz.guess()
                ),
                EventStartDateString: moment(event.EventStartDate, [
                  "DD-MM-YYYY",
                ]).format("MMM DD, YYYY"), //self.formatDate(data.EventStartDate),
                EventEndDateString: moment(event.EventEndDate, [
                  "DD-MM-YYYY",
                ]).format("MMM DD, YYYY"),
                EventNewEndTime: self.SetTimeByZone(
                  moment(event.EventEndDate, ["DD-MM-YYYY"]).format(
                    "MMM DD, YYYY"
                  ) +
                    " " +
                    endTime,
                  moment.tz.guess()
                ),
                IsPublished: event.IsPublished,
                StatusClass: event.IsPublished ? "" : "event-unpublished",
                status: event.status,
                clientID: event.ClientId,
                eventDefaultSessionPage: event.DefaultSessionPath
                  ? event.DefaultSessionPath
                  : "",
                DefaultLanguage:
                  event.DefaultLanguage === undefined
                    ? "English"
                    : event.DefaultLanguage,
              });
            }
            store.commit("setMappedEvent", mappedEvents);
            store.commit("addEventCount", mappedEvents.length);
          }
          self.refreshToken(response.data.customToken);
          self.EventsLoaded = true;
          bus.$emit("toggleLoader", false);
        })
        .catch((error) => {
          console.log(error);
        });
      // if (self.tabclickflag != true) {
      //   if (self.liveflag <= 0) {
      //     self.fliterflag = 2;
      //     $("#aEndedtab").removeClass("active");
      //     $("#aLivetab").removeClass("active");
      //     $("#aunderreviewtab").addClass("active");
      //     $("#aAlltab").removeClass("active");
      //     if (self.UnderReviewFlag <= 0 && self.liveflag <= 0) {
      //       self.fliterflag = 0;
      //       $("#aEndedtab").addClass("active");
      //       $("#aLivetab").removeClass("active");
      //       $("#aunderreviewtab").removeClass("active");
      //       $("#aAlltab").removeClass("active");

      //       if (
      //         self.Pastflag <= 0 &&
      //         self.UnderReviewFlag <= 0 &&
      //         self.liveflag <= 0
      //       ) {
      //         self.fliterflag = 3;
      //         $("#aEndedtab").removeClass("active");
      //         $("#aLivetab").removeClass("active");
      //         $("#aunderreviewtab").removeClass("active");
      //         $("#aAlltab").addClass("active");
      //       }
      //     }
      //   }
      // }

      // self.tabclickflag = false;
      // if (self.EventsData.length > 0) {
      //   self.eventCount = self.EventsData.length;
      //   if (self.fliterflag == 1) {
      //     debugger;
      //     self.EventsData = self.EventsData.filter(function (e) {
      //       return e.status == "live" || e.status == "upcoming";
      //     });
      //   } else if (self.fliterflag == 2) {
      //     self.EventsData = self.EventsData.filter(function (e) {
      //       return e.status == "underreview";
      //     });
      //   } else if (self.fliterflag == 0) {
      //     self.EventsData = self.EventsData.filter(function (e) {
      //       return e.status == "ended";
      //     });
      //   } else {
      //     debugger;
      //     self.EventsData = self.EventsData.filter(function (e) {
      //       return e.status.Contains(
      //         "live",
      //         "upcoming",
      //         "underreview",
      //         "ended"
      //       );
      //     });
      //   }
      // } else {
      //   self.eventCount = 0;
      // }
      //store.commit("addEventCount", self.eventCount);

      // if (self.sortOrder == "desc") {
      //   self.EventsData = self.EventsData.sort(function compare(a, b) {
      //     //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
      //     var dateA = parseInt(new Date(a.EventStartDateTime).getTime() / 1000);
      //     var dateB = parseInt(new Date(b.EventStartDateTime).getTime() / 1000);
      //     return dateB - dateA;
      //   });
      // } else {
      //   self.EventsData = self.EventsData.sort(function compare(a, b) {
      //     //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
      //     var dateA = parseInt(new Date(a.EventStartDateTime).getTime() / 1000);
      //     var dateB = parseInt(new Date(b.EventStartDateTime).getTime() / 1000);
      //     return dateA - dateB;
      //   });
      // }

      // if (self.eventCount == 1) {
      //   self.gotolobby = true;
      //   alert(self.$t("eventlist.routeMessageOnSingleEvent"));
      //   self.$router.push(eventDoc[1].DefaultLandingURL);
      //   self.goToEvent(eventDoc, eventDoc.DefaultSessionPath);
      // } else if (self.eventCount > 1) {
      //   self.gotolobby = false;
      // } else {
      //   //Not registered to any event
      //   //router.push({ name: "Login" });
      // }
    },
    refreshToken(token) {
      firebase
        .auth()
        .signInWithCustomToken(token)
        .then(function (res) {
          res.user
            .getIdToken(true)
            .then((idToken) => {
              var decoded = jwt_decode(idToken);
              document.cookie = "token=";
              document.cookie = "token=" + idToken + ";";
              self.$store.commit("addToken", idToken);
              self.$store.commit("setCurrentLoggedInTime", decoded.exp);
              document.cookie = "staysigned=";
              document.cookie = "userrole=";
              document.cookie = "userid=";
            })
            .catch((err) => {
              console.log("err=====", err);
            });
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MMM DD, YYYY");
      return date;
    },
    displayEventsReg() {
      //debugger;
      this.pageIndex++;
      var listRef = db
        .collection("OA_UAT/ClientList/Clients")
        .doc(self.clientID)
        .collection("Events");
      var cnt = 0;
      listRef
        //.where("IsPublished", "==", true)
        //.where("AllowRegistration", "==", true)
        .where("EventTypeId", "==", 2)
        //.get()
        .onSnapshot((querySnapshot) => {
          this.EventsData = [];
          debugger;
          if (querySnapshot.docs.length > 0) {
            querySnapshot.forEach((doc) => {
              cnt++;
              var data = doc.data();
              /* this.EventsData.push({
                id: doc.id,
                Name: data.EventFullName,
                EventLogo: data.EventLogo,
                EventStartDate: data.EventStartDate,
                EventEndDate: data.EventEndDate,
                EventCollectionName: data.EventCollectionName,
                EventTypeId: data.EventTypeId,
                EventTimezone: data.TimeZone,
                EventStartDateString: self.formatDate(data.EventStartDate),
                EventEndDateString: self.formatDate(data.EventEndDate)
              });*/
              var obj = new Object();
              obj.id = doc.id;
              obj.Name = data.EventFullName;
              obj.EventLogo = data.EventLogo;
              // obj.EventStartDate = data.EventStartDate;
              // obj.EventEndDate = data.EventEndDate;
              obj.EventCollectionName = data.EventCollectionName;
              obj.EventTypeId = data.EventTypeId;
              obj.EventTimezone = moment.tz.guess(); //data.TimeZone;
              //-------------------------------------------------------------------------------------------
              /* var mZone = moment.tz.guess();
              //obj.EventStartDateString = self.formatDate(data.EventStartDate);
              if (data.TimeZone != mZone) {
                var EventStartDate = self.formatDateTimeZoneWise(
                  data.EventStartDate
                );
                var momnt = moment.tz(EventStartDate, data.TimeZone);
                var strtDate = momnt.clone().tz(moment.tz.guess());
                obj.EventStartDateString = self.GetActualDateFormat(
                  strtDate.format()
                );
              } else {
                obj.EventStartDateString = self.formatDate(data.EventStartDate);
              }*/
              var dateFormat = require("dateformat");

              var dtstrt = new Date(data.EventStartDate.seconds * 1000);
              obj.EventStartDateString = dateFormat(dtstrt, "mmm dd, hh:MM TT");
              // obj.EventStartDateString = moment(dtstrt).format(
              //   " MMMM Do, h:mm a"
              // );
              //self.formatDate(data.EventStartDate);
              //------------------------------------------------------------------------------------------------
              /*if (data.TimeZone != mZone) {
                // obj.EventEndDateString = self.formatDate(data.EventEndDate);
                var EventEndDate = self.formatDateTimeZoneWise(
                  data.EventEndDate
                );
                var momnt2 = moment.tz(EventEndDate, data.TimeZone);
                var endDate = momnt2.clone().tz(moment.tz.guess());
                obj.EventEndDateString = self.GetActualDateFormat(
                  endDate.format()
                );
              } else {
                obj.EventEndDateString = self.formatDate(data.EventEndDate);
              }*/
              var dtend = new Date(data.EventEndDate.seconds * 1000);
              obj.EventEndDateString = dateFormat(dtend, "mmm dd, hh:MM TT"); // self.formatDate(data.EventEndDate);
              obj.EventStartDate = data.EventStartDate;
              obj.EventEndDate = data.EventEndDate;
              //------------------------------------------------------------------------------------------------
              self.EventsData.push(obj);
            });
            //debugger;
            self.noEventMessage = self.EventsData.length > 0 ? false : true;
            self.EventsData = self.EventsData.sort(function compare(a, b) {
              //debugger;
              //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
              var dateA = parseInt(
                new Date(a.EventStartDate.seconds * 1000).getTime() / 1000
              );
              var dateB = parseInt(
                new Date(b.EventStartDate.seconds * 1000).getTime() / 1000
              );
              return dateB - dateA;
            });
            if (cnt == 1) {
              //debugger;
              //router.push({
              //  path:
              //    "/event/" +
              //    this.EventsData[0].id +
              //    "/" +
              //    this.EventsData[0].Name
              //});
              router.push({
                path: "/event/" + this.EventsData[0].id,
              });
            }
          } else {
            self.noEventMessage = true;
          }
        });
      // .catch(error => {
      //   alert(error);
      //   // console.log("Error getting documents: ", error);
      // });
    },
    GetActualDateFormat: function (actualDt) {
      var dt = actualDt.split("T");
      var oDt = new Date(dt[0]).toDateString();

      var oTt = dt[1];
      var arrDate = oDt.split(" ");
      var accDate = arrDate[1] + " " + arrDate[2];

      var arrtime = oTt.split(":");
      var accTime = arrtime[0] + ":" + arrtime[1];

      var fullStartDate = accDate + " " + accTime;
      return fullStartDate;
    },
    formatDateTimeZoneWise: function (seconds) {
      var dateString = "";
      try {
        var dt = new Date(seconds.seconds * 1000);
        //debugger;

        var hrs = dt.getHours();
        hrs = hrs == 0 ? "00" : hrs;
        if (hrs != "00" && parseInt(hrs) < 10) {
          hrs = "0" + hrs;
        }

        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }

        var mnths = dt.getMonth();
        var accurateMon = mnths + 1;
        if (parseInt(accurateMon) < 10) {
          accurateMon = "0" + accurateMon;
        }

        dateString +=
          dt.getFullYear() +
          "-" +
          accurateMon +
          "-" +
          dt.getDate() +
          " " +
          hrs +
          ":" +
          minutes;

        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    selectEvent: function (eventId, evntName) {
      console.log("evntName:--- " + evntName);
      router.push({
        path: "/event/" + eventId,
      });
    },
    formatDate: function (seconds) {
      var dateString = "";
      //  alert(seconds);
      // if (seconds == 1594125120) {
      //   debugger;
      // }
      try {
        var dt = new Date(seconds.seconds * 1000);
        const monthNamesShort = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }
        dateString +=
          dt.getDate() +
          " " +
          monthNamesShort[dt.getMonth()] +
          " " +
          dt.getHours() +
          ":" +
          minutes;
        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    /* ,
    computed: {
      BannerURL() {
        // debugger;
        // var obj = JSON.parse(window.localStorage.getItem("my-app"));
        // return obj.branding[0].banner;
        //  db.collection("OA_UAT")
        //         .doc("ClientList")
        //         .collection("Clients")
        //         .where("CustomDomain", "==", this.result)
        //         .get()
        //         .then(querySnapshot => {
        //           querySnapshot.forEach(doc => {
        //           });
        //         });
      },
      pageBg() {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        return obj.EventBranding[0].bg2;
      }
    }*/
  },
};
</script>
<style>
.ss_event_listTab table > thead > tr > th:nth-child(1) {
  z-index: 1;
}
.no-reg-events {
  margin: 0 auto;
  text-align: center;
}
.no-reg-events h3 {
  font-weight: 700;
  font-size: 30px;
  color: #333;
  margin-bottom: 25px;
}
.no-reg-events a {
  display: inline-block;
  padding: 8px 30px;
  background: #00a982;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.5);
  margin-top: 15px;
}
.no-reg-events a:active {
  transform: translateY(5px);
  box-shadow: none;
}
.event-list-register-shimmer photo {
  display: block;
  width: 100%;
  height: 88px;
}
.shine {
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  display: inline-block;
  position: relative;

  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeholderShimmer;
  -webkit-animation-timing-function: linear;
}
.top-right-login.hdr-btn {
  padding: 0 0 15px;
}
.top-right-login.hdr-btn a.login,
.top-right-login.hdr-btn a.event-List {
  font-size: 18px;
  padding-right: 0 !important;
  margin-left: 25px;
  cursor: pointer;
  background-position: left center;
}
.left-logo.edu-banner {
  width: 100% !important;
}
.event-box-list-wrapper .ev-box {
  border-radius: 5px;
  cursor: pointer;
}
section.event-box-list-wrapper {
  margin-top: 25px;
}
@media only screen and (max-width: 767px) {
  /* .left-logo.edu-banner {
  display: none;
} */
  .left-logo.edu-banner a {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left-logo.edu-banner a img {
    width: 100%;
    height: 100%;
  }
  .reg-event-banner {
    padding: 20px 0 !important;
    margin-top: 24px;
  }
  .edu-rage .reg-event-banner h1 {
    margin-top: 0;
  }
}
</style>
